import React from 'react';
import { Helmet } from 'react-helmet';

const HelmetNoIndex: React.FC = () => (
  <Helmet>
    <meta name="robots" content="noindex" />
  </Helmet>
);

export default HelmetNoIndex;
